import { DestroyRef, Directive, inject, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GenericFeatureFlagService } from '@rma/generic/ng/feature-flags/internal';

@Directive({
  selector: '[rmaIfFeatureFlag]',
  standalone: true,
})
export class GenericIfFeatureFlagDirective<Flag extends string = string> implements OnInit {
  @Input()
  public rmaIfFeatureFlag: Flag | undefined;

  private readonly vcRef = inject(ViewContainerRef);
  private readonly tplRef = inject(TemplateRef<unknown>);
  private readonly featureFlagService = inject(GenericFeatureFlagService);
  private readonly destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    if (!this.rmaIfFeatureFlag) {
      return;
    }

    this.featureFlagService
      .getLiveFeature$(this.rmaIfFeatureFlag, false)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((enabled) => {
        this.vcRef.clear();
        if (enabled) {
          this.vcRef.createEmbeddedView(this.tplRef);
        }
      });
  }
}
